/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  MutationKey,
  useMutation,
  UseMutationResult,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { metaMcpDelete } from "../funcs/metaMcpDelete.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { GramError } from "../models/errors/gramerror.js";
import {
  ConnectionError,
  InvalidRequestError,
  RequestAbortedError,
  RequestTimeoutError,
  UnexpectedClientError,
} from "../models/errors/httpclienterrors.js";
import { ResponseValidationError } from "../models/errors/responsevalidationerror.js";
import { SDKValidationError } from "../models/errors/sdkvalidationerror.js";
import { ServiceError } from "../models/errors/serviceerror.js";
import {
  DeleteMetaMcpServerRequest,
  DeleteMetaMcpServerSecurity,
} from "../models/operations/deletemetamcpserver.js";
import { unwrapAsync } from "../types/fp.js";
import { useGramContext } from "./_context.js";
import { MutationHookOptions } from "./_types.js";

export type DeleteMetaMcpServerMutationVariables = {
  request: DeleteMetaMcpServerRequest;
  security?: DeleteMetaMcpServerSecurity | undefined;
  options?: RequestOptions;
};

export type DeleteMetaMcpServerMutationData = void;

export type DeleteMetaMcpServerMutationError =
  | ServiceError
  | GramError
  | ResponseValidationError
  | ConnectionError
  | RequestAbortedError
  | RequestTimeoutError
  | InvalidRequestError
  | UnexpectedClientError
  | SDKValidationError;

/**
 * deleteMetaMcpServer metaMcp
 *
 * @remarks
 * Delete a meta MCP server. Its live memberships and MCP endpoints are deleted along with it.
 */
export function useDeleteMetaMcpServerMutation(
  options?: MutationHookOptions<
    DeleteMetaMcpServerMutationData,
    DeleteMetaMcpServerMutationError,
    DeleteMetaMcpServerMutationVariables
  >,
): UseMutationResult<
  DeleteMetaMcpServerMutationData,
  DeleteMetaMcpServerMutationError,
  DeleteMetaMcpServerMutationVariables
> {
  const client = useGramContext();
  return useMutation({
    ...buildDeleteMetaMcpServerMutation(client, options),
    ...options,
  });
}

export function mutationKeyDeleteMetaMcpServer(): MutationKey {
  return ["@gram/client", "metaMcp", "delete"];
}

export function buildDeleteMetaMcpServerMutation(
  client$: GramCore,
  hookOptions?: RequestOptions,
): {
  mutationKey: MutationKey;
  mutationFn: (
    variables: DeleteMetaMcpServerMutationVariables,
  ) => Promise<DeleteMetaMcpServerMutationData>;
} {
  return {
    mutationKey: mutationKeyDeleteMetaMcpServer(),
    mutationFn: function deleteMetaMcpServerMutationFn({
      request,
      security,
      options,
    }): Promise<DeleteMetaMcpServerMutationData> {
      const mergedOptions = {
        ...hookOptions,
        ...options,
        fetchOptions: {
          ...hookOptions?.fetchOptions,
          ...options?.fetchOptions,
          signal: combineSignals(
            hookOptions?.fetchOptions?.signal,
            options?.fetchOptions?.signal,
          ),
        },
      };
      return unwrapAsync(metaMcpDelete(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}
